
import { useContractFunction } from '@usedapp/core';
import { buyTruthAddresses } from '../shared/config';
import BuyTruthABI from '@buytruth/contracts/artifacts/contracts/BuyTruth.sol/BuyTruth.json';
import { Contract } from 'ethers';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface DialogProps {
    chainId?: number;
    open: boolean;
    onClose: () => void;
  }

export default function ClaimConfirmation({ chainId, open, onClose } : DialogProps) {
  
  const btContract = chainId && new Contract(buyTruthAddresses[chainId], BuyTruthABI.abi);
  const claimRewards = useContractFunction(btContract, 'claimRewards') 
  
  const handleTransfer = () => {
    claimRewards.send();
  }

  const resetAndClose = () => {
    claimRewards.resetState();
    onClose();
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={resetAndClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{color: '#000'}}>
          {"Claim Rewards"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p>Once you claim, your holdings eligible for rewards will be reset. If you would like to claim rewards again, you will need to purchase more BuyTruth tokens </p>
            <p style={{margin: '10px 0', fontWeight: 'bold', color: '#a50000'}}>Important: Claiming will reset your 90 day holding timer</p>
            { claimRewards.state.status === 'Exception' || claimRewards.state.status === 'Fail' ? <Alert severity="error"><AlertTitle>Whoops!</AlertTitle>Transaction failure occurred, please try again...</Alert> : <></>}
            { claimRewards.state.status === 'Mining' || claimRewards.state.status === 'PendingSignature' ? <Alert severity="info"><AlertTitle>Working on it!</AlertTitle>Waiting for approval in your wallet...</Alert> : <></>}
            { claimRewards.state.status === 'Success' ? <Alert severity="success"><AlertTitle>Congrats on successfully claiming your reward!</AlertTitle>"And without faith it is impossible to please Him, for whoever would draw near to God must believe that He exists and that He rewards those who seek him" - <b>Hebrews 11:6</b></Alert> : <></>}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          { claimRewards.state.status === 'Success' ?
            <>
              <Button onClick={resetAndClose}>Close</Button>
            </>
          :
            <>
              <Button onClick={handleTransfer} autoFocus>Claim Rewards</Button>
              <Button onClick={resetAndClose}>Hold off...</Button>
            </>
          }
        </DialogActions>
      </Dialog>
    </div>
  );
}